module.exports = __webpack_public_path__ + "img/Inleiding.b5f64862.jpg";